<script lang="ts">

</script>

<main>
  <h1>subpage</h1>
</main>

<style lang="scss">
  main {
    h1 {
      color: blue;
    }
  }
</style>
